import {
  FilterSelect,
  type FilterSelectOption,
  type FilterSelectProps,
} from "./filter-select";

export type SortSelectOption = FilterSelectOption;
export type SortSelectProps = FilterSelectProps;

export function SortSelect(props: SortSelectProps) {
  return <FilterSelect {...props} />;
}
